import { useState } from 'react';
import styled from '@emotion/styled';
import { useParams } from 'react-router-dom';

import { ToastManager } from '../../../ToastManager.jsx';

import { useApi } from '../../../store/SelectedHomeyStore.js';
import { useUser } from '../../../store/users/useUsers.ts';
import { useI18n } from '../../../hooks/useI18nFormatters.tsx';
import { useUserMe } from '../../../store/users/useUserMe.ts';

import { theme } from '../../../theme/theme.ts';
import { su } from '../../../theme/functions/su.js';
import { publicUrl } from '../../../theme/functions/publicUrl.js';

import { SpinnerFade } from '../../../components/common/SpinnerFade.jsx';
import { Dialog } from '../../../components/overlay/Dialog.jsx';
import { SolidButton } from '../../../components/buttons/SolidButton.tsx';
import { IconButton } from '../../../components/buttons/IconButton.tsx';

import { iconCloseThin } from '../../../theme/icons/interface/close-thin/index.js';

export function FamilySettingsDialogDisableLocalUser(props) {
  const { i18n } = useI18n();
  const params = useParams();
  const { api } = useApi();

  const { user } = useUser({ userId: params.userId });
  const { userMe } = useUserMe();

  const [isDisablingLocalUser, setIsDisablingLocalUser] = useState(false);

  function handleClosePress() {
    props.onCloseRequest();
  }

  return (
    <Dialog
      containFocus={true}
      // autoFocus={true}
      onClose={() => {
        props.onCloseRequest();
      }}
    >
      <S.Root>
        <S.CloseIconButtonWrapper>
          <IconButton
            url={iconCloseThin}
            color={theme.color.icon_light}
            size={theme.icon.size_small}
            onPress={handleClosePress}
          />
        </S.CloseIconButtonWrapper>

        <S.Avatar src={user.avatar || publicUrl(`img/ph-64.png`)} />

        <S.Title>
          {i18n.messageFormatter('settings.system.usersLocalUserDisableDialogTitle')}
        </S.Title>

        <S.Info>
          {i18n.messageFormatter('settings.system.usersLocalUserDisableDialogSubtitle')}
        </S.Info>

        <S.Actions>
          <SolidButton
            isDisabled={isDisablingLocalUser === true}
            styleFlat={true}
            styleColor="red"
            onPress={() => {
              setIsDisablingLocalUser(true);

              if (userMe.id !== user.id && userMe.role === 'owner') {
                api
                  .call({
                    method: 'DELETE',
                    path: `/api/manager/users/user/${user.id}/local-credentials`,
                    timeout: 5 * 1000,
                  })
                  .then(() => {
                    props.onCloseRequest();
                  })
                  .catch((error) => {
                    ToastManager.handleError(error);
                    setIsDisablingLocalUser(false);
                  })
                  .finally(() => {});
                return;
              }

              api
                .call({
                  method: 'DELETE',
                  path: `/api/manager/users/user/me/local-credentials`,
                  timeout: 5 * 1000,
                })
                .then(() => {
                  props.onCloseRequest();
                })
                .catch((error) => {
                  ToastManager.handleError(error);
                  setIsDisablingLocalUser(false);
                })
                .finally(() => {});
              // onAction('local-user');
            }}
          >
            <SpinnerFade
              isActive={isDisablingLocalUser === true}
              color={theme.color.white}
              size={theme.icon.size_small}
            />
            <SolidButton.Text>{i18n.messageFormatter('common.disable')}</SolidButton.Text>
          </SolidButton>
        </S.Actions>
      </S.Root>
    </Dialog>
  );
}

function S() {}
FamilySettingsDialogDisableLocalUser.S = S;

S.Root = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  width: 360px;
  padding: ${su(4)} ${su(2)} ${su(2)};
`;

S.CloseIconButtonWrapper = styled.div`
  position: absolute;
  right: ${su(2)};
  top: ${su(2)};
`;

S.Title = styled.h3`
  text-align: center;
  padding-top: ${su(2)};
`;

S.Info = styled.p`
  color: ${theme.color.text_light};
  text-align: center;
`;

S.Avatar = styled.img`
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
  border-radius: 50%;
  box-shadow: ${theme.boxShadow.default};
`;

S.Actions = styled.div`
  display: grid;
  width: 100%;
  grid-auto-flow: column;
  grid-gap: ${su(1)};
`;
